import React, { useRef, useState, useEffect } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoButton from 'eco-design/base/eco-button';
import styles from './index.module.scss';
import useCardsShowHook from '../useHooks/useCardsShowHook';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar, Pagination } from 'swiper';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const SenceCard: React.FC = () => {
    const { t } = useLang('Delta3AirStation.SenceCard');
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [slidesOffset, setSlidesOffset] = useState<any>(undefined);
    const swiperRef = useRef<any>(null);

    useCardsShowHook('#SenceCard .sence-item-img', '#SenceCard');

    const contentList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761704709595/sence-card-1-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761704709595/sence-card-1-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761704708143/sence-card-1-m.jpg',
            desc: t('desc1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761704710076/sence-card-2-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761704710076/sence-card-2-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761704709241/sence-card-2-m.jpg',
            desc: t('desc2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761704708855/sence-card-3-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761704708855/sence-card-3-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761704708469/sence-card-3-m.jpg',
            desc: t('desc3'),
        },
    ];

    const handlePush = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_button',
            button_name: '',
        });
    };

    const onMouseHover = (index: number) => {
        const eles = document.querySelectorAll('#SenceCard .sence-item-img');
        eles.forEach((ele, i) => {
            if (index === i) {
                ele.classList.add('active');
                handlePush();
            } else {
                ele.classList.remove('active');
            }
        });
    };

    const onSlideChange = (swiper: any) => {
        const { activeIndex, previousIndex } = swiper;
        if (activeIndex > previousIndex) {
            console.log('👉 向左滑动（下一个）');
            handlePush();
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setSlidesOffset(24);
            } else if (window.innerWidth < 1024) {
                setSlidesOffset(48);
            } else if (window.innerWidth < 1340) {
                setSlidesOffset(120);
            } else {
                const offset = (window.innerWidth - 1200) / 2;
                setSlidesOffset(offset);
            }

            const eles = document.querySelectorAll('#SenceCard .sence-item-img');
            eles[0].classList.add('active');
        }
    }, []);

    return (
        <section className={`${styles.SenceCard} GtmModuleData-section`} id="SenceCard" data-section-id="SenceCard">
            <div className="title">{t('title')}</div>
            <div className="sence-container">
                {/* pc需要动效，h5需要swiper滑动，那就只能分两块 */}
                <div className="swiper-wrap-h5">
                    <Swiper
                        modules={[Navigation, Pagination]}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        spaceBetween={16}
                        pagination
                        slidesOffsetBefore={slidesOffset}
                        slidesOffsetAfter={slidesOffset}
                        slidesPerView={'auto'}
                        onSlideChange={onSlideChange}
                    >
                        {contentList.map((item, index) => (
                            <SwiperSlide key={index} className="sence-slide">
                                <EcoImg className="sence-img" pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy />
                                <div className="sence-desc">{item.desc}</div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="sence-wrap-pc">
                    <div className="sence-list">
                        {contentList.map((item, index) => (
                            <div className={`sence-item-img`} key={index} onMouseEnter={() => onMouseHover(index)}>
                                <EcoImg className="sence-img" pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy />
                                <div className="sence-desc">{item.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SenceCard;
